import React from "react";

const GuarantorSuccess = ({
  id,
  isGuarantorSuccessOpen,
  closeGuarantorSuccess,
  selectedGuarantor,
}) => {
  const handleCancelButtonCLick = () => {
    closeGuarantorSuccess();
  };

  return (
    <>
      <div
        id={id}
        className={`${
          isGuarantorSuccessOpen ? "flex" : "hidden"
        } flex items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div className="flex items-center justify-center w-full">
          <div className="relative bg-white shadow-lg rounded-sm w-[90%] max-w-[58%] mx-auto">
            <div className="mb-8 mx-auto items-center justify-center">
              <div className="flex items-center justify-between">
                <button
                  onClick={closeGuarantorSuccess}
                  type="button"
                  className="bg-transparent  rounded-lg text-sm ml-auto inline-flex items-center "
                  data-modal-toggle={id}
                >
                  <svg
                    width="61"
                    height="43"
                    viewBox="0 0 61 43"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_13891_3896)">
                      <path
                        d="M32.84 28L30.7 24.9L28.9 28H25.2L28.88 22.3L25.1 16.84H28.94L31.08 19.92L32.88 16.84H36.58L32.84 22.46L36.68 28H32.84Z"
                        fill="black"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_13891_3896">
                        <rect width="61" height="43" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </button>
              </div>
              <div className="h-[250px] w-full flex flex-col gap-[20px] items-center justify-center">
                <p className="text-center text-[16px] font-[600]">SUCCESS!</p>
                <svg
                  width="84"
                  height="84"
                  viewBox="0 0 84 84"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M42.0001 83.3333C64.8279 83.3333 83.3334 64.8278 83.3334 42C83.3334 19.1722 64.8279 0.666656 42.0001 0.666656C19.1723 0.666656 0.666748 19.1722 0.666748 42C0.666748 64.8278 19.1723 83.3333 42.0001 83.3333Z"
                    fill="#7FB8EB"
                  />
                  <path
                    d="M23.9167 36.8333L38.8691 51.7857C39.0144 51.9308 39.2114 52.0123 39.4167 52.0123C39.6221 52.0123 39.8191 51.9308 39.9644 51.7857L80.7501 11"
                    stroke="black"
                    stroke-width="1.2"
                  />
                </svg>

                <p className="items-center text-center text-[14px]">
                  <span className="font-bold">
                    {selectedGuarantor?.name
                      ?.split(" ")
                      ?.map(
                        (nam) =>
                          nam?.charAt(0)?.toUpperCase() +
                          nam?.slice(1)?.toLowerCase()
                      )
                      ?.join(" ")}
                  </span>{" "}
                  [Member ID:{" "}
                  <span className="font-bold">
                    {selectedGuarantor?.memberID}
                  </span>
                  ] has been successfully removed as a guarantor for this loan.
                  They have been notified of this action. Please ensure all
                  guarantorship requirements are met to avoid delays in the loan
                  approval process.
                </p>
              </div>

              <div className="flex items-center justify-center mt-5 mx-5">
                <button
                  onClick={handleCancelButtonCLick}
                  data-modal-toggle={id}
                  type="button"
                  className="text-[#FF5757] bg-[#FFFFFF] hover:bg-[#FFFFFF] border border-[#FF5757] focus:outline-none font-[500] rounded-[5px] text-[16px] text-medium px-10 py-2 text-center"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GuarantorSuccess;
